import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store/index'

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI, { size: 'small' });

import Print from 'vue-print-nb'
Vue.use(Print)

import BtnTag from './components/BtnTag'
Vue.component('btn-tag', BtnTag)

import FileButton from '@/components/fileBtn'
Vue.use(FileButton)

import DrillLink from '@/components/drillLink'
Vue.use(DrillLink)

import FixBaseSelect from '@/components/select/fix_base_select'
Vue.component('FixBaseSelect', FixBaseSelect)

import Pagination from 'vue-pagination-2'
Vue.component('pagination', Pagination)

import Vuelidate from 'vuelidate'
Vue.use(Vuelidate)

import VueMomentLib from "vue-moment-lib"
Vue.use(VueMomentLib)

import util from './utils/index';
Vue.use(util)

import VuejsDialog from 'vuejs-dialog'
import 'vuejs-dialog/dist/vuejs-dialog.min.css'
Vue.use(VuejsDialog, {
	okText: '确定',
	cancelText: '取消'
})

Vue.config.productionTip = false

import './permission' // permission control

import permission from '@/directive/permission'
Vue.directive('code', permission)

new Vue({
	router,
	store,
	render: h => h(App)
}).$mount('#app')
